import Lenis from 'lenis'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

function SmoothScroll({ children }) {
  const location = useLocation()
  const disableLenis = location.pathname.startsWith('/dashboard')

  useEffect(() => {
    if (disableLenis) {
      if (window.__lenis) {
        try {
          window.__lenis.destroy()
        } catch (_) {
          /* ignore */
        }
        delete window.__lenis
      }
      return undefined
    }

    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      smoothWheel: true,
      wheelMultiplier: 1,
      smoothTouch: false,
      touchMultiplier: 2,
      infinite: false,
    })

    window.__lenis = lenis

    let rafId = 0
    function raf(time) {
      lenis.raf(time)
      rafId = requestAnimationFrame(raf)
    }
    rafId = requestAnimationFrame(raf)

    return () => {
      cancelAnimationFrame(rafId)
      if (window.__lenis === lenis) {
        delete window.__lenis
      }
      lenis.destroy()
    }
  }, [disableLenis])

  return children
}

export default SmoothScroll
